import useSkipModules from '~/composables/useSkipModules';
import { type WindowIncludingLoadedScript } from '~/types';

export default defineNuxtPlugin((nuxt) => {
  const { skipModule, moduleNames } = useSkipModules(nuxt._route);
  if (skipModule(moduleNames.AIMJS)) {
    return;
  }
  useHead({
    script: [
      {
        key: 'aim-js',
        src: 'https://assets.adnuntius.com/aim.js',
        async: true
      }
    ]
  });
});
